import * as React from "react";
import styled from "styled-components";
const HEIGHT = 32;
const WIDTH = 32;
const STRENGTH = 2;
const OFFSET = 7;
const COLOR = "#444444";
const Container = styled.div `
  width: ${WIDTH}px;
  height: ${HEIGHT}px;
  position: relative;
  /* margin: ${(HEIGHT - OFFSET * 2 - STRENGTH) / 2}px 0; */

  top: ${OFFSET}px;

  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: ${STRENGTH}px;
    width: 100%;
    background: ${COLOR};
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2),
    &:nth-child(3) {
      top: ${OFFSET}px;
    }
    &:nth-child(4) {
      top: ${OFFSET * 2}px;
    }
  }

  &.open {
    span {
      &:nth-child(1),
      &:nth-child(4) {
        top: 18px;
        width: 0%;
        left: 50%;
      }
      &:nth-child(2) {
        transform: rotate(45deg);
      }
      &:nth-child(3) {
        transform: rotate(-45deg);
      }
    }
  }
`;
export const Hamburger = React.memo(function Hamburger({ open, setOpen, }) {
    return (React.createElement(Container, { className: open ? "open" : undefined, onClick: () => {
            setOpen(!open);
        } },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null)));
});
//# sourceMappingURL=data:application/json;base64,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